import * as React from "react";
import styled from "styled-components";
const HEIGHT = 32;
const WIDTH = 32;
const STRENGTH = 2;
const OFFSET = 7;
const COLOR = "#444444";
const Container = styled.div `
  width: ${WIDTH}px;
  height: ${HEIGHT}px;
  position: relative;
  /* margin: ${(HEIGHT - OFFSET * 2 - STRENGTH) / 2}px 0; */

  top: ${OFFSET}px;

  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: ${STRENGTH}px;
    width: 100%;
    background: ${COLOR};
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2),
    &:nth-child(3) {
      top: ${OFFSET}px;
    }
    &:nth-child(4) {
      top: ${OFFSET * 2}px;
    }
  }

  &.open {
    span {
      &:nth-child(1),
      &:nth-child(4) {
        top: 18px;
        width: 0%;
        left: 50%;
      }
      &:nth-child(2) {
        transform: rotate(45deg);
      }
      &:nth-child(3) {
        transform: rotate(-45deg);
      }
    }
  }
`;
export const Hamburger = React.memo(function Hamburger({ open, setOpen, }) {
    return (React.createElement(Container, { className: open ? "open" : undefined, onClick: () => {
            setOpen(!open);
        } },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null)));
});
//# sourceMappingURL=data:application/json;base64,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